var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseWithoutPadding = function SvgCloseWithoutPadding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.21 5.999-4.89 4.89.757.757L5.96 6.761l4.888 4.957.763-.752-4.893-4.962 4.964-4.964-.757-.758-4.96 4.959L1.08.285l-.762.752z",
    clipRule: "evenodd"
  })));
};
export { SvgCloseWithoutPadding as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTIiIGZpbGw9Im5vbmUiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjIwOTE4IDUuOTk4NThMMC4zMTkxNyAxMC44ODg2TDEuMDc2NzggMTEuNjQ2Mkw1Ljk2MTQ5IDYuNzYxNDlMMTAuODQ4OSAxMS43MTc4TDExLjYxMTggMTAuOTY1NUw2LjcxOTEyIDYuMDAzODZMMTEuNjgzNCAxLjAzOTZMMTAuOTI1OCAwLjI4MTk4Mkw1Ljk2NjgxIDUuMjQwOTRMMS4wNzk0MyAwLjI4NDY2NEwwLjMxNjUyOCAxLjAzNjk2TDUuMjA5MTggNS45OTg1OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";